import { render } from "./FileItem.vue?vue&type=template&id=4a976ab8&scoped=true&bindings={}"
import script from "./FileItem.vue?vue&type=script&lang=ts"
export * from "./FileItem.vue?vue&type=script&lang=ts"

import "./FileItem.vue?vue&type=style&index=0&id=4a976ab8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4a976ab8"

export default script